import React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import Button from "components/button";
import { useReportDownloadError } from "../../../redux/report-download-hooks";
import { Dispatch } from "redux";
import { RootActionTypes } from "../../../redux/root-action";
import { downloadReportExit } from "../../../redux/report-download-actions";
import { useTranslation } from "react-i18next";

const ButtonWrapper = styled.div`
  > * {
    margin-top: 20px;
    float: right;
  }
`;

const ReportModalError: React.FC = () => {
  const dispatch = useDispatch<Dispatch<RootActionTypes>>();
  const { t } = useTranslation();
  const close = () => dispatch(downloadReportExit());
  const error = useReportDownloadError();

  return (
    <div>
      {error || "An unexpected error occurred."}
      <ButtonWrapper>
        <Button onClick={close}>{t("close")}</Button>
      </ButtonWrapper>
    </div>
  );
};

export default ReportModalError;
